<template>
  <v-card>
    <v-card-title class="headline"
      >Confirmar acción
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <h3 class="mt-5 ml-5">¿Está seguro que desea cancelar este mandado?</h3>
    </v-card-text>

    <v-card-actions>
      <v-row class="pa-0 ma-0">
        <v-col class="mb-0 pb-0" cols="6" sm="6" md="6">
          <v-btn
            color="#6f6f6f"
            dark
            class="mb-3"
            rounded
            :min-height="48"
            block
            :loading="loading"
            @click="$emit('cancel')"
          >
            Salir
          </v-btn>
        </v-col>
        <v-col class="mb-0 pb-0" cols="6" sm="6" md="6">
          <v-btn
            color="red darken-4"
            dark
            class="mb-3"
            rounded
            block
            :min-height="48"
            :loading="loading"
            @click="$emit('confirm')"
          >
            Cancelar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["name", "loading"],
};
</script>